import React from 'react'
import ReactMarkdown from 'react-markdown'
import { MarkdownItemImage } from './MarkdownItemImage'
import { MarkdownItemLinkiOS } from './MarkdownItemLinkiOS'

interface Props {
  content: string
}

export const MarkdowniOS = ({ content }: Props) => {
  return (
    <ReactMarkdown
      source={content}
      escapeHtml={false}
      renderers={{
        image: MarkdownItemImage,
        link: MarkdownItemLinkiOS
      }}
    />
  )
}
